// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Preview Mode Buttons */
.ResponseTemplateEditor_previewModeButtons__ykO5N {
  display: flex;
  gap: 8px;
  margin: 12px 0 16px 0;
}

.ResponseTemplateEditor_previewModeButton__8\\+70- {
  padding: 6px 16px;
  background: #f0f0f0;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
}

.ResponseTemplateEditor_previewModeButton__8\\+70-:hover {
  background: #e8e8e8;
}

.ResponseTemplateEditor_previewModeButton__8\\+70-.ResponseTemplateEditor_activePreviewMode__WzU9Q {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

.ResponseTemplateEditor_previewModeButton__8\\+70-.ResponseTemplateEditor_activePreviewMode__WzU9Q:hover {
  background: #0056b3;
}

/* Default Preview Styles */
.ResponseTemplateEditor_previewSection__RlbrM {
  margin-top: 16px;
}

.ResponseTemplateEditor_previewBox__NgbJ1 {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 12px;
  min-height: 60px;
  white-space: pre-wrap;
  word-break: break-word;
}

/* Tile Preview Styles */
.ResponseTemplateEditor_tilePreviewSection__2FVe8 {
  margin-top: 16px;
}

.ResponseTemplateEditor_tilePreviewBox__EbRgn {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 12px;
  min-height: 60px;
}

.ResponseTemplateEditor_tileBorder__oKG3j {
  border: 2px solid #007bff;
  border-radius: 8px;
  padding: 16px;
  background: white;
  min-height: 40px;
  white-space: pre-wrap;
  word-break: break-word;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.ResponseTemplateEditor_textarea__K0lPB:focus {
  outline: none;
  border-color: var(--editBtn);
  box-shadow: 0 0 0 4px rgba(163, 112, 206, 0.1);
  transform: translateY(-1px);
}

.ResponseTemplateEditor_textarea__K0lPB:hover {
  border-color: var(--editBtn);
}

.ResponseTemplateEditor_input__q28Iy:disabled,
.ResponseTemplateEditor_textarea__K0lPB:disabled,
.ResponseTemplateEditor_statusInput__ezGTj:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.7;
}

.ResponseTemplateEditor_textarea__K0lPB {
  resize: vertical;
  min-height: 100px;
  max-height: 400px;
  font-family: "Fira Code", "Courier New", monospace;
  font-size: 0.9rem;
  line-height: 1.6;
  padding: 10px 14px;
  border: 2px solid #e8eaed;
  border-radius: 10px;
  transition: all 0.3s ease;
  background: var(--white-color);
  color: var(--dark-color, #1e1e1e);
  width: 100%;
  overflow-y: auto;
}

.ResponseTemplateEditor_textarea__K0lPB::placeholder {
  color: rgb(18, 16, 16);
  opacity: 0.7;
  font-weight: 400;
}

.ResponseTemplateEditor_input__q28Iy::placeholder,
.ResponseTemplateEditor_statusInput__ezGTj::placeholder {
  color: rgb(18, 16, 16);
  opacity: 0.8;
}

.ResponseTemplateEditor_textarea__K0lPB:focus::placeholder {
  opacity: 0.4;
  transition: all 0.3s ease;
}

/* ─── Scrollbar ─── */
.ResponseTemplateEditor_textarea__K0lPB::-webkit-scrollbar {
  width: 8px;
}

.ResponseTemplateEditor_textarea__K0lPB::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.ResponseTemplateEditor_textarea__K0lPB::-webkit-scrollbar-thumb {
  background: var(--editBtn, #3797fe);
  border-radius: 4px;
}

.ResponseTemplateEditor_textarea__K0lPB::-webkit-scrollbar-thumb:hover {
  background: var(--editHover, #0056b3);
}
.ResponseTemplateEditor_textarea__K0lPB:focus-visible,



.ResponseTemplateEditor_formGroup__0CwNs {
  margin-bottom: 1.5rem;
  position: relative;
}

.ResponseTemplateEditor_formGroup__0CwNs:last-of-type {
  margin-bottom: 1rem;
}

/* ─── Helper Text ─── */
.ResponseTemplateEditor_helperText__jvm5r {
  font-size: 0.8rem;
  color: var(--text-color, #6b6b6b);
  margin-top: 0.25rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.ResponseTemplateEditor_suggestionsList__WWnkk {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  max-height: 150px;
  overflow-y: auto;
  z-index: 1000;
  list-style: none;
  margin: 0;
  padding: 0;
}
.ResponseTemplateEditor_suggestionsList__WWnkk li {
  padding: 6px 12px;
  cursor: pointer;
}
.ResponseTemplateEditor_suggestionsList__WWnkk li:hover {
  background: #e3f2fd;
}

.ResponseTemplateEditor_statusTabs__UNZ8I {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 12px 0;
  padding: 20px 0px;
}

.ResponseTemplateEditor_statusTab__zYyTp {
  padding: 9px 20px;
  background: #f1f3f4;
  border: 1px solid #dadce0;
  border-radius: 20px;
  cursor: pointer;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.ResponseTemplateEditor_statusTab__zYyTp.ResponseTemplateEditor_activeTab__i0uy2 {
  background: #1976d2;
  color: white;
  border-color: #1976d2;
}

.ResponseTemplateEditor_removeStatus__nTses {
  cursor: pointer;
  font-weight: bold;
  margin-left: 4px;
  font-size: 16px;
}

.ResponseTemplateEditor_removeStatus__nTses:hover {
  color: #d32f2f;
}

.ResponseTemplateEditor_addStatusButton__l\\+mSj {
  padding: 6px 14px;
  background: #e8f5e9;
  border: 1px dashed #4caf50;
  border-radius: 20px;
  cursor: pointer;
  font-size: 13px;
  color: #2e7d32;
}

.ResponseTemplateEditor_addStatusButton__l\\+mSj:hover {
  background: #c8e6c9;
}

.ResponseTemplateEditor_container__tle-I {
  border: 1px solid #e8eaed;
  border-radius: 12px;
  padding: 20px;
  margin-top: 20px;
  background: linear-gradient(135deg, #fafafa 0%, #ffffff 100%);
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.ResponseTemplateEditor_container__tle-I:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.ResponseTemplateEditor_title__EN-35 {
  margin-top: 0;
  margin-bottom: 12px;
  font-size: 1.125rem;
  font-weight: 600;
  color: #202124;
  padding-bottom: 8px;
  border-bottom: 2px solid #e8eaed;
}

.ResponseTemplateEditor_description__T2XRJ {
  font-size: 0.913rem;
  color: #5f6368;
  margin-bottom: 20px;
  line-height: 1.5;
}

.ResponseTemplateEditor_label__g7mGY {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: var(--dark2-color, #4d4d4d);
  font-size: 0.95rem;
  justify-content: center;
  margin-bottom: 20px;
}

.ResponseTemplateEditor_textareaError__fMcvK {
  border-color: var(--deleteBtn);
}

.ResponseTemplateEditor_textareaError__fMcvK:focus {
  border-color: var(--deleteHover);
  box-shadow: 0 0 0 3px rgba(234, 67, 53, 0.1);
}

.ResponseTemplateEditor_errorMessage__FjFSn {
  color: var(--deleteBtn);
  font-size: 0.75rem;
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.ResponseTemplateEditor_errorMessage__FjFSn::before {
  content: "⚠️";
  font-size: 0.75rem;
}

.ResponseTemplateEditor_helperText__jvm5r {
  display: block;
  color: #5f6368;
  margin-top: 10px;
  font-size: 0.75rem;
  line-height: 1.4;
  font-style: italic;
}

.ResponseTemplateEditor_helperText__jvm5r code {
  background: #f1f3f4;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.85rem;
  color: var(--deleteBtn);
}
.ResponseTemplateEditor_resplabel__sAAN3 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}
.ResponseTemplateEditor_sampleWrap__G86eE {
  display: flex;
  gap: 10px;
  padding: 10px;
  border-radius: 6px;
  align-items: center;
  justify-content: space-between;
  box-shadow:
    rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
}

.ResponseTemplateEditor_fieldButtons__qnkDc {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
  /* padding-bottom: 20px; */
}

.ResponseTemplateEditor_fieldButton__3u0Ep {
  padding: 12px;
  font-size: 0.75rem;
  background: linear-gradient(135deg, #f1f3f4 0%, #e8eaed 100%);
  color: var(--editBtn);
  border: 1px solid #dadce0;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
}

.ResponseTemplateEditor_fieldButton__3u0Ep:hover:not(:disabled) {
  background: linear-gradient(135deg, #e8f0fe 0%, #d2e3fc 100%);
  border-color: #1a73e8;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(26, 115, 232, 0.2);
}

.ResponseTemplateEditor_fieldButton__3u0Ep:disabled {
  background: #f8f9fa;
  color: #9aa0a6;
  cursor: not-allowed;
  border-color: #e8eaed;
}

.ResponseTemplateEditor_previewSection__RlbrM {
  margin-top: 20px;
}

.ResponseTemplateEditor_previewBox__NgbJ1 {
  margin-top: 8px;
  padding: 14px;
  background: white;
  border: 1px solid #dadce0;
  border-radius: 8px;
  white-space: pre-wrap;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 0.875rem;
  line-height: 1.6;
  color: #202124;
  min-height: 60px;
  max-height: 300px;
  overflow-y: auto;
  transition: all 0.2s ease;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
}

.ResponseTemplateEditor_previewBox__NgbJ1:focus-within {
  border-color: #1a73e8;
  box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.1);
}

/* Scrollbar styling for preview box */
.ResponseTemplateEditor_previewBox__NgbJ1::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.ResponseTemplateEditor_previewBox__NgbJ1::-webkit-scrollbar-track {
  background: #f1f3f4;
  border-radius: 4px;
}

.ResponseTemplateEditor_previewBox__NgbJ1::-webkit-scrollbar-thumb {
  background: #dadce0;
  border-radius: 4px;
}

.ResponseTemplateEditor_previewBox__NgbJ1::-webkit-scrollbar-thumb:hover {
  background: #bdc1c6;
}

/* Responsive Design */
@media (max-width: 768px) {
  .ResponseTemplateEditor_container__tle-I {
    padding: 16px;
  }

  .ResponseTemplateEditor_title__EN-35 {
    font-size: 1rem;
  }

  .ResponseTemplateEditor_fieldButtons__qnkDc {
    gap: 6px;
  }

  .ResponseTemplateEditor_fieldButton__3u0Ep {
    font-size: 0.688rem;
    padding: 5px 10px;
  }

  .ResponseTemplateEditor_previewBox__NgbJ1 {
    font-size: 0.813rem;
    padding: 12px;
  }
}

/* Animation for field buttons */
@keyframes ResponseTemplateEditor_fadeInButton__fdwBy {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.ResponseTemplateEditor_fieldButton__3u0Ep {
  animation: ResponseTemplateEditor_fadeInButton__fdwBy 0.2s ease-out;
}

/* Animation for preview box */
@keyframes ResponseTemplateEditor_slideUp__x5zmO {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ResponseTemplateEditor_previewBox__NgbJ1 {
  animation: ResponseTemplateEditor_slideUp__x5zmO 0.3s ease-out;
}

/* Loading state for preview */
.ResponseTemplateEditor_previewBox__NgbJ1:empty::before {
  content: "(No preview yet)";
  color: #9aa0a6;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/ResponseUI/ResponseTemplateEditor.module.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;EAGE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kDAAkD;EAClD,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,iCAAiC;EACjC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;AACA;;;;;EAKE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,6DAA6D;EAC7D,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B;;0CAEwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,6DAA6D;EAC7D,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB;qEACmE;EACnE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,sCAAsC;AACtC;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,mEAAqC;AACvC;;AAEA,8BAA8B;AAC9B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,8DAAgC;AAClC;;AAEA,8BAA8B;AAC9B;EACE,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;AACpB","sourcesContent":["/* Preview Mode Buttons */\n.previewModeButtons {\n  display: flex;\n  gap: 8px;\n  margin: 12px 0 16px 0;\n}\n\n.previewModeButton {\n  padding: 6px 16px;\n  background: #f0f0f0;\n  border: 1px solid #d0d0d0;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: all 0.2s;\n}\n\n.previewModeButton:hover {\n  background: #e8e8e8;\n}\n\n.previewModeButton.activePreviewMode {\n  background: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n.previewModeButton.activePreviewMode:hover {\n  background: #0056b3;\n}\n\n/* Default Preview Styles */\n.previewSection {\n  margin-top: 16px;\n}\n\n.previewBox {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 12px;\n  min-height: 60px;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n/* Tile Preview Styles */\n.tilePreviewSection {\n  margin-top: 16px;\n}\n\n.tilePreviewBox {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 12px;\n  min-height: 60px;\n}\n\n.tileBorder {\n  border: 2px solid #007bff;\n  border-radius: 8px;\n  padding: 16px;\n  background: white;\n  min-height: 40px;\n  white-space: pre-wrap;\n  word-break: break-word;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.textarea:focus {\n  outline: none;\n  border-color: var(--editBtn);\n  box-shadow: 0 0 0 4px rgba(163, 112, 206, 0.1);\n  transform: translateY(-1px);\n}\n\n.textarea:hover {\n  border-color: var(--editBtn);\n}\n\n.input:disabled,\n.textarea:disabled,\n.statusInput:disabled {\n  background: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.textarea {\n  resize: vertical;\n  min-height: 100px;\n  max-height: 400px;\n  font-family: \"Fira Code\", \"Courier New\", monospace;\n  font-size: 0.9rem;\n  line-height: 1.6;\n  padding: 10px 14px;\n  border: 2px solid #e8eaed;\n  border-radius: 10px;\n  transition: all 0.3s ease;\n  background: var(--white-color);\n  color: var(--dark-color, #1e1e1e);\n  width: 100%;\n  overflow-y: auto;\n}\n\n.textarea::placeholder {\n  color: rgb(18, 16, 16);\n  opacity: 0.7;\n  font-weight: 400;\n}\n\n.input::placeholder,\n.statusInput::placeholder {\n  color: rgb(18, 16, 16);\n  opacity: 0.8;\n}\n\n.textarea:focus::placeholder {\n  opacity: 0.4;\n  transition: all 0.3s ease;\n}\n\n/* ─── Scrollbar ─── */\n.textarea::-webkit-scrollbar {\n  width: 8px;\n}\n\n.textarea::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.textarea::-webkit-scrollbar-thumb {\n  background: var(--editBtn, #3797fe);\n  border-radius: 4px;\n}\n\n.textarea::-webkit-scrollbar-thumb:hover {\n  background: var(--editHover, #0056b3);\n}\n.textarea:focus-visible,\n\n\n/* ─── Form Groups ─── */\n.formGroup {\n  margin-bottom: 1.5rem;\n  position: relative;\n}\n\n.formGroup:last-of-type {\n  margin-bottom: 1rem;\n}\n\n/* ─── Helper Text ─── */\n.helperText {\n  font-size: 0.8rem;\n  color: var(--text-color, #6b6b6b);\n  margin-top: 0.25rem;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.suggestionsList {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  max-height: 150px;\n  overflow-y: auto;\n  z-index: 1000;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.suggestionsList li {\n  padding: 6px 12px;\n  cursor: pointer;\n}\n.suggestionsList li:hover {\n  background: #e3f2fd;\n}\n\n.statusTabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 12px 0;\n  padding: 20px 0px;\n}\n\n.statusTab {\n  padding: 9px 20px;\n  background: #f1f3f4;\n  border: 1px solid #dadce0;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.statusTab.activeTab {\n  background: #1976d2;\n  color: white;\n  border-color: #1976d2;\n}\n\n.removeStatus {\n  cursor: pointer;\n  font-weight: bold;\n  margin-left: 4px;\n  font-size: 16px;\n}\n\n.removeStatus:hover {\n  color: #d32f2f;\n}\n\n.addStatusButton {\n  padding: 6px 14px;\n  background: #e8f5e9;\n  border: 1px dashed #4caf50;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 13px;\n  color: #2e7d32;\n}\n\n.addStatusButton:hover {\n  background: #c8e6c9;\n}\n\n.container {\n  border: 1px solid #e8eaed;\n  border-radius: 12px;\n  padding: 20px;\n  margin-top: 20px;\n  background: linear-gradient(135deg, #fafafa 0%, #ffffff 100%);\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.container:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.title {\n  margin-top: 0;\n  margin-bottom: 12px;\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #202124;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #e8eaed;\n}\n\n.description {\n  font-size: 0.913rem;\n  color: #5f6368;\n  margin-bottom: 20px;\n  line-height: 1.5;\n}\n\n.label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  color: var(--dark2-color, #4d4d4d);\n  font-size: 0.95rem;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.textareaError {\n  border-color: var(--deleteBtn);\n}\n\n.textareaError:focus {\n  border-color: var(--deleteHover);\n  box-shadow: 0 0 0 3px rgba(234, 67, 53, 0.1);\n}\n\n.errorMessage {\n  color: var(--deleteBtn);\n  font-size: 0.75rem;\n  margin-top: 10px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.errorMessage::before {\n  content: \"⚠️\";\n  font-size: 0.75rem;\n}\n\n.helperText {\n  display: block;\n  color: #5f6368;\n  margin-top: 10px;\n  font-size: 0.75rem;\n  line-height: 1.4;\n  font-style: italic;\n}\n\n.helperText code {\n  background: #f1f3f4;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  color: var(--deleteBtn);\n}\n.resplabel {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 10px;\n}\n.sampleWrap {\n  display: flex;\n  gap: 10px;\n  padding: 10px;\n  border-radius: 6px;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow:\n    rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,\n    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\n}\n\n.fieldButtons {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 8px;\n  /* padding-bottom: 20px; */\n}\n\n.fieldButton {\n  padding: 12px;\n  font-size: 0.75rem;\n  background: linear-gradient(135deg, #f1f3f4 0%, #e8eaed 100%);\n  color: var(--editBtn);\n  border: 1px solid #dadce0;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-weight: 500;\n}\n\n.fieldButton:hover:not(:disabled) {\n  background: linear-gradient(135deg, #e8f0fe 0%, #d2e3fc 100%);\n  border-color: #1a73e8;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 6px rgba(26, 115, 232, 0.2);\n}\n\n.fieldButton:disabled {\n  background: #f8f9fa;\n  color: #9aa0a6;\n  cursor: not-allowed;\n  border-color: #e8eaed;\n}\n\n.previewSection {\n  margin-top: 20px;\n}\n\n.previewBox {\n  margin-top: 8px;\n  padding: 14px;\n  background: white;\n  border: 1px solid #dadce0;\n  border-radius: 8px;\n  white-space: pre-wrap;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  font-size: 0.875rem;\n  line-height: 1.6;\n  color: #202124;\n  min-height: 60px;\n  max-height: 300px;\n  overflow-y: auto;\n  transition: all 0.2s ease;\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.previewBox:focus-within {\n  border-color: #1a73e8;\n  box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.1);\n}\n\n/* Scrollbar styling for preview box */\n.previewBox::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.previewBox::-webkit-scrollbar-track {\n  background: #f1f3f4;\n  border-radius: 4px;\n}\n\n.previewBox::-webkit-scrollbar-thumb {\n  background: #dadce0;\n  border-radius: 4px;\n}\n\n.previewBox::-webkit-scrollbar-thumb:hover {\n  background: #bdc1c6;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .container {\n    padding: 16px;\n  }\n\n  .title {\n    font-size: 1rem;\n  }\n\n  .fieldButtons {\n    gap: 6px;\n  }\n\n  .fieldButton {\n    font-size: 0.688rem;\n    padding: 5px 10px;\n  }\n\n  .previewBox {\n    font-size: 0.813rem;\n    padding: 12px;\n  }\n}\n\n/* Animation for field buttons */\n@keyframes fadeInButton {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.fieldButton {\n  animation: fadeInButton 0.2s ease-out;\n}\n\n/* Animation for preview box */\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.previewBox {\n  animation: slideUp 0.3s ease-out;\n}\n\n/* Loading state for preview */\n.previewBox:empty::before {\n  content: \"(No preview yet)\";\n  color: #9aa0a6;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"previewModeButtons": `ResponseTemplateEditor_previewModeButtons__ykO5N`,
	"previewModeButton": `ResponseTemplateEditor_previewModeButton__8+70-`,
	"activePreviewMode": `ResponseTemplateEditor_activePreviewMode__WzU9Q`,
	"previewSection": `ResponseTemplateEditor_previewSection__RlbrM`,
	"previewBox": `ResponseTemplateEditor_previewBox__NgbJ1`,
	"tilePreviewSection": `ResponseTemplateEditor_tilePreviewSection__2FVe8`,
	"tilePreviewBox": `ResponseTemplateEditor_tilePreviewBox__EbRgn`,
	"tileBorder": `ResponseTemplateEditor_tileBorder__oKG3j`,
	"textarea": `ResponseTemplateEditor_textarea__K0lPB`,
	"input": `ResponseTemplateEditor_input__q28Iy`,
	"statusInput": `ResponseTemplateEditor_statusInput__ezGTj`,
	"formGroup": `ResponseTemplateEditor_formGroup__0CwNs`,
	"helperText": `ResponseTemplateEditor_helperText__jvm5r`,
	"suggestionsList": `ResponseTemplateEditor_suggestionsList__WWnkk`,
	"statusTabs": `ResponseTemplateEditor_statusTabs__UNZ8I`,
	"statusTab": `ResponseTemplateEditor_statusTab__zYyTp`,
	"activeTab": `ResponseTemplateEditor_activeTab__i0uy2`,
	"removeStatus": `ResponseTemplateEditor_removeStatus__nTses`,
	"addStatusButton": `ResponseTemplateEditor_addStatusButton__l+mSj`,
	"container": `ResponseTemplateEditor_container__tle-I`,
	"title": `ResponseTemplateEditor_title__EN-35`,
	"description": `ResponseTemplateEditor_description__T2XRJ`,
	"label": `ResponseTemplateEditor_label__g7mGY`,
	"textareaError": `ResponseTemplateEditor_textareaError__fMcvK`,
	"errorMessage": `ResponseTemplateEditor_errorMessage__FjFSn`,
	"resplabel": `ResponseTemplateEditor_resplabel__sAAN3`,
	"sampleWrap": `ResponseTemplateEditor_sampleWrap__G86eE`,
	"fieldButtons": `ResponseTemplateEditor_fieldButtons__qnkDc`,
	"fieldButton": `ResponseTemplateEditor_fieldButton__3u0Ep`,
	"fadeInButton": `ResponseTemplateEditor_fadeInButton__fdwBy`,
	"slideUp": `ResponseTemplateEditor_slideUp__x5zmO`
};
export default ___CSS_LOADER_EXPORT___;
